export interface PendingAppleBatch {
    requestId: string
    expiry: string
    ready: boolean
}
const key = (offerId: string) => `mobile-offer-pending-batch:${offerId}`

/** Non-secret operation metadata only. Never store codes or store credentials in the browser. */
export function readAppleBatch(offerId: string): PendingAppleBatch | null {
    const raw = localStorage.getItem(key(offerId))
    if (!raw) return null
    const value: unknown = JSON.parse(raw)
    if (
        !value ||
        typeof value !== 'object' ||
        !('requestId' in value) ||
        typeof value.requestId !== 'string' ||
        !('expiry' in value) ||
        typeof value.expiry !== 'string' ||
        !('ready' in value) ||
        typeof value.ready !== 'boolean'
    )
        throw new Error('Saved batch state is invalid. Ask engineering to reconcile this batch before creating another.')
    return value as PendingAppleBatch
}
export const saveAppleBatch = (offerId: string, batch: PendingAppleBatch) => localStorage.setItem(key(offerId), JSON.stringify(batch))
export const clearReadyAppleBatch = (offerId: string) => {
    const batch = readAppleBatch(offerId)
    if (batch && !batch.ready) throw new Error('An unfinished code batch must be reconciled first.')
    localStorage.removeItem(key(offerId))
}
